import React from "react";

export const ButtonSpinner = (props : {width?: string, height?: string}) => {
    const widthSpinner = props.width ? props.width : "2rem";
    const heightSpinner = props.height ? props.height : "2rem";
    return (
        <div style={{width: widthSpinner, height: heightSpinner}} className={"spinner-border text-light m-05"}></div>
    )
};